<script setup lang="ts">
  import { computed } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import DocumentIcon from '@/shared/assets/icons/DocumentIcon.svg';
  import SendIcon from '@/shared/assets/icons/SendIcon.svg';
  import BuildingIcon from '@/shared/assets/icons/building.svg';
  import { TabsMenu } from '@/shared/ui';

  const router = useRouter();
  const route = useRoute();

  const OPTIONS = [
    {
      id: 'lista-documentos',
      text: 'Lista de Documentos',
      icon: DocumentIcon,
    },
    {
      id: 'controle-envio',
      text: 'Controle de Envio',
      icon: SendIcon,
    },
    {
      id: 'locais-htm',
      text: 'Locais HTM',
      icon: BuildingIcon,
    },
  ];

  const selectedOption = computed(() => {
    const [, currentPathSegment] = route.path.split('/').filter(Boolean);

    return OPTIONS.find((option) => option.id === currentPathSegment)?.id ?? 'lista-documentos';
  });

  const handleOptionSelect = (optionId: string) => {
    router.push(`/gestao-documentos/${optionId}`);
  };
</script>

<template>
  <div
    data-testid="document-management-page"
    class="pt-4 p-6"
  >
    <h3 class="text-gray-07 text-xl/7.5 font-semibold text-left mb-6">
      Gestão de Documentos
    </h3>
    <TabsMenu
      :options="OPTIONS"
      :selected-option="selectedOption"
      class="mb-6"
      @option-selected="handleOptionSelect"
    />
    <router-view />
  </div>
</template>
